<template>
  <div class="grid-container full targetOxbridgeBox page-contents-15">
    <div class="grid-x">
      <div class=" small-12 cell text-center">
        <div class="grid-x">
          <div class="small-12 cell">
            <h2>Target Oxbridge</h2>
          </div>
        </div>

          <div class="grid-x">
            <div class="small-12 cell text-center">
              <p>Target Oxbridge is a free programme that helps students of Black African and Caribbean heritage secure offers from the Universities of Oxford and Cambridge.</p>
              <p>For the first decade of the programme, 41% of Target Oxbridge students secured Oxbridge offers, which is double the average offer rate.</p>
            </div>
          </div>

        <div class="grid-x contactButton">
          <div class="small-12 cell">

            <rare-standard-button
            class="contactButton show-for-small-only"
            :active="'true'"
            :buttonText="'Find out more'"
            :height="'40px'"
            :fontColor="'#ffffff'"
            :fontSize="'12px'"
            @clicked="findOutMore"
          />
            <rare-standard-button
              class="contactButton show-for-medium"
              :buttonText="'Find out more'"
              :height="'64px'"
              :width="'282px'"
              :fontColor="'#ffffff'"
              :fontSize="'16px'"
              @clicked="findOutMore"
            />

          </div>
        </div>

        <div class="grid-x">
          <div class="small-12 cell">
          <p class="workingWith">Working together with</p>
          </div>
        </div>

        <div class="grid-x uniLogoCont">
          <div class="small-6 cell">
            <a href="http://www.ox.ac.uk/" target="_blank" rel="noopener">
            <img
              class="oxfordUniImg"
              src="@/assets/img/logos/home-page-logos/oxford-uni-white.png"
              alt="Oxford University Logo - Graduate"/>
            </a>
          </div>
          <div class="small-6 cell">
            <a href="http://www.cam.ac.uk/" target="_blank" rel="noopener">
            <img
              class="cambridgeUniImg"
              src="@/assets/img/logos/home-page-logos/cambridge-uni-white.png"
              alt="Cambridge University Logo - Recruitment"/>
            </a>
        </div>
        </div>


      </div>
    </div>
  </div>
</template>

<script>
import RareStandardButton from '@/components/atoms/RareWebButton';
import RareEmailIcon from 'rare-patternlab/icons/communication/RareEmailIconWhite';
import RarePhoneIcon from 'rare-patternlab/icons/communication/RarePhoneIconWhite';

export default {
  name: 'RareCandidatesTargetOxbridge',
  components: {
    'rare-standard-button': RareStandardButton,
    'rare-email-icon': RareEmailIcon,
    'rare-phone-icon': RarePhoneIcon,
  },
  methods: {
    findOutMore() {
      window.open('https://targetoxbridge.co.uk/', '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .targetOxbridgeBox {
    background-position: center;
    background-image: url("../../../assets/img/backgrounds/target-oxbridge.jpg");
  }

  h2
  {
    color: #ffffff;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: center;
  }


  @media only screen and (max-width: 640px)  {


    h2 {
       font-size: 24px;
       line-height: 1.33;
       margin: 40px 0 16px 0;
     }

    p {
      color: #ffffff;
      font-size: 14px;
      font-weight: normal;
      font-style: normal;
      line-height: 1.71;
      font-stretch: normal;
    }

    .contactButton {
      margin: 0 auto 10px auto;
    }
  }

  .uniLogoCont {
    margin-bottom: 53px;
  }

  .oxfordUniImg {
    height: 37px;
    float: right;
    margin-right: 10px;
  }

  .cambridgeUniImg {
    height: 26px;
    float: left;
    margin-left: 10px;
    margin-top: 6px;
  }


  @media only screen and (min-width: 641px)  {

    h2 {
      font-size: 56px;
      line-height:1.29;
      margin: 90px 0 24px 0;
    }

    p {
      color: #ffffff;
      font-size: 21px;
      font-weight: normal;
      font-style: normal;
      line-height: 1.52;
      font-stretch: normal;
    }

    .contactButton {
      margin: 30px auto 0 auto;
    }

    .workingWith {
      font-size: 14px;
      margin: 35px auto 20px auto;
    }

    .uniLogoCont {
      margin-bottom: 96px;
    }

    .oxfordUniImg {
      height: 40px;
      float: right;
      margin-right: 10px;
    }

    .cambridgeUniImg {
      height: 28px;
      float: left;
      margin-left: 10px;
      margin-top: 6px;
    }

  }

</style>



// WEBPACK FOOTER //
// src/pages/candidates/components/RareCandidatesTargetOxbridge.vue